module.exports = __webpack_public_path__ + "img/eligibilite3.7a9c8124.jpg";